import { Validators } from '@angular/forms';
import { Injectable } from '@angular/core';
import { Forms } from './forms-list';
import { ICustomControl } from '../models/form.model';

@Injectable({providedIn: 'root'})
export class FormService {
	public configureControls(controls: ICustomControl[], prefix?: string): any[] {
		const group: any = {};
		if (this._isArray(controls)) {
			controls.forEach((control: ICustomControl) => {
				// control.label = control.label ? control.label : `${ prefix }${ control.id }.label`;
				control.type = control.type ? control.type : `${ prefix }${ control.id }`;
				group[control.id] = this.configureControl(control);
			});
		}
		return group;
	}

	public configureControl(control: ICustomControl): any[] {

		// First of all we add initial value. Mock 'null' value if haven't stored value
		const output: any[] = [control.value ? control.value : null],
			// Initialize empty validators array.
			validators: any[] = [];

		if (control.validators) {
			if (this._isArray(control.validators)) {
				control.validators.forEach((validatorName) => {
					const validator: any = this._setValidator(control, validatorName);
					if (validator) {
						// console.log('pushing validator for', validatorName, validator);
						validators.push(validator);
					}
				});
			} else if (typeof control.validators === 'string') {
				this._setValidator(control, control.validators as string);
				// console.log('validators 2', validators);
			}
		}
		// Add an array of validators to the end of the control array.
		// console.log('validators result', validators);

		output.push(validators);
		// console.log('validators', validators);
		return output;
	}

	public findControl(controls: Array<ICustomControl>, searchId): ICustomControl {
		let result = controls.find(c => c.id === searchId);
		if (result === undefined) {
			throw new Error('IControl with id = ' + searchId + 'hasn\'t found');
		} else {
			return result;
		}
	}

	private _isArray(subject: any[] | any): boolean {
		return typeof subject === 'object' && subject.constructor === Array;
	}

	private _setValidator(input: ICustomControl, key: string): boolean {
		// Check if validator should accept parameters.
		// console.log('key', key, 'input', input);
		const isValidatorTakesValue: boolean =
			key === 'min' ||
			key === 'max' ||
			key === 'minLength' ||
			key === 'maxLength'
		// key === 'pattern';
		// console.log('isValidatorTakesValue', isValidatorTakesValue);
		if (isValidatorTakesValue) {
			// console.log('input[key]', input[key]);

			// Check if input value exist to each validator.
			if (!input[key]) {
				// console.log('!input[key]');
				this._warning(key);
				return true;
			}
		} else {
			return Validators[key]; // If validator shouldn't accept any parameters.
		}

		// console.log(key, input[key]);
		const newVar: any = Validators[key](input[key]);
		// console.log('created Validator', newVar);
		return newVar;
	}

	private _warning(key: string): void {
		// This is just a warning method.
		let prefix = '';
		switch (key) {
			case 'min': {
				prefix = 'Min length number';
				break;
			}
			case 'max': {
				prefix = 'Max number';
				break;
			}
			case 'minLength': {
				prefix = 'Min length number';
				break;
			}
			case 'maxLength': {
				prefix = 'Max length number';
				break;
			}
			case 'pattern': {
				prefix = 'Pattern string';
				break;
			}
			default: {
				prefix = 'Some value';
				break;
			}
		}
		console.warn(
			`'${ prefix }' doesn't exist in control configuration. Please, check '${ key }' configuration.`,
		);
	}

	get signUpControls(): Array<ICustomControl> {
		return Forms.signUp;
	}

	get signUpSocialLoginControls(): Array<ICustomControl> {
		return Forms.signUpSocialLogin;
	}

	get editPhoneEmail(): Array<ICustomControl> {
		return Forms.editPhoneEmail;
	}

	get signInControls(): Array<ICustomControl> {
		return Forms.signIn;
	}

	get paymentControls(): Array<ICustomControl> {
		return Forms.payment;
	}

	get voucherControls(): Array<ICustomControl> {
		return Forms.voucher;
	}

	get sharedControls(): Array<ICustomControl> {
		return Forms.sharedBooking;
	}

	get userControls(): Array<ICustomControl> {
		return Forms.user;
	}

	get changePasswordControls(): Array<ICustomControl> {
		return Forms.changePassword;
	}

	get forgotPasswordControls(): Array<ICustomControl> {
		return Forms.forgotPassword;
	}

	get newPasswordControls(): Array<ICustomControl> {
		return Forms.newPassword;
	}

	get boxControls(): Array<ICustomControl> {
		return Forms.box;
	}

	get bookingControls(): Array<ICustomControl> {
		return Forms.booking;
	}
	get filterControls(): Array<ICustomControl> {
		return Forms.filter;
	}


	convertToObject(controls: Array<ICustomControl>) {
		const result = {};
		controls.forEach(c => {
			result[c.id] = c;
		});

		// console.log('result', result);
	}

}
